;(function ($, window, document, undefined) {
    'use strict';

    var UserSettings = function (element, options) {
        this.opts = options;
        this.els  = options.els;

        this.init();
    };

    UserSettings.prototype = {

        init : function () {
            this.$fieldset = $('#fieldset');
            this.checkbox();
            this.select();
            this.layout();
        },

        layout: function () {
            $('.lia-quilt-column-00 .lia-mark-empty').closest('.lia-form-row').hide();
        },

        checkbox: function () {
            this.$fieldset.find('input[type="checkbox"]').after('<div class="check"><span class="icon"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="35" height="28.32" viewBox="0 0 17.5 14.16"><path d="M17.515,2.524 L5.932,14.166 L5.914,14.148 L5.897,14.166 L0.001,8.241 L2.519,5.710 L5.914,9.122 L14.997,-0.007 L17.515,2.524 Z" class="cls-1"></path></svg></span></div>');
            this.$fieldset.find('input[type="checkbox"]').each(function () {
                $(this).closest('.lia-form-row').addClass('lia-form-row-checkbox');
            });

            this.$fieldset.find('.check').click(function() {
                $(this).prev().click();
            });
        },

        select: function () {
            this.$fieldset.find('select').parent().addClass('select-box').append('<span class="icon icon--dark"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="28.75" height="20.06" viewBox="0 0 14.375 10.03"><path d="M7.253,4.589 L11.586,0.047 L14.363,2.777 L7.253,10.016 L-0.002,2.628 L2.582,-0.004 L7.253,4.589 Z" class="cls-1"></path></svg></span>');
        }
    };

    $.fn.UserSettings = function (options) {

        var args     = Array.prototype.slice.call(arguments, 1),
            $item    = $(this),
            instance = $item.data('UserSettings');

        if (!instance) {
            instance = new UserSettings(this, options);
            $item.data('UserSettings', instance);
        }

        if (typeof options === 'string') {
            instance[options].apply(instance, args);
        }

        return this;
    };

})(jQuery, window, document);
